export default {
    points: [
        { x: 3, y: 160.28 },
        { x: 4, y: 160.39 },
        { x: 5, y: 160.51 },
        { x: 6, y: 160.63 },
        { x: 7, y: 160.68 },
        { x: 8, y: 160.74 },
    ],
    yTicks: [0, 25, 50, 75, 100, 125, 150, 175, 200]
}